import React from 'react';
import { InternalProvider } from '../../../util';
import { CalendarSvg, NoTimesAvailableContainer } from './elements';
export const NoTimesAvailable = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(NoTimesAvailableContainer, rest, /*#__PURE__*/React.createElement(CalendarSvg, null), children));